(() => {
  const eventNames = ['select', 'datetime', 'text-4', 'text-5', 'text-6', 'textarea'];
  const contactNames = ['text', 'text-2', 'email', 'phone', 'text-3'];
  const knownNames = new Set([...eventNames, ...contactNames]);
  const roots = document.querySelectorAll('[data-ab-quote]');

  roots.forEach((root) => {
    if (root.dataset.aqBound) return;
    root.dataset.aqBound = 'true';
    const mount = root.querySelector('[data-aq-mount]');
    if (!mount) return;

    const enhance = () => {
      const form = mount.querySelector('form[data-id="1258"][name="globo-form-1258"]');
      if (!form || form.dataset.aqEnhanced) return Boolean(form);
      const wizard = form.querySelector('.globo-formbuilder-wizard[data-steps-quantity="1"]');
      const footer = form.querySelector('.gfb__page-footer');
      const nativeSubmit = footer?.querySelector('button[type="submit"]');
      const controls = Array.from(form.querySelectorAll('input:not([type="hidden"]), select, textarea'));
      const missingField = [...knownNames].some((name) => !controls.some((field) => field.name === name));
      if (!wizard || !footer || !nativeSubmit || missingField || controls.some((field) => !knownNames.has(field.name))) return false;
      if (controls.some((field) => !field.closest('.globo-form-control'))) return false;

      const progress = root.querySelector('[data-aq-progress]');
      const count = root.querySelector('[data-aq-count]');
      const navigation = root.querySelector('[data-aq-navigation]');
      const next = root.querySelector('[data-aq-next]');
      const back = root.querySelector('[data-aq-back]');
      const all = root.querySelector('[data-aq-all]');
      const title = root.querySelector('[data-aq-title]');
      const lead = root.querySelector('[data-aq-lead]');
      const error = root.querySelector('[data-aq-error]');
      if ([progress, count, navigation, next, back, all, title, lead, error].some((node) => !node)) return false;

      const eventControls = controls.filter((field) => eventNames.includes(field.name));
      const byName = (name) => controls.find((field) => field.name === name);
      controls.forEach((field) => {
        if (field.hasAttribute('presence')) {
          field.setAttribute('required', '');
          field.setAttribute('aria-required', 'true');
        }
      });
      Object.entries({ text: 'family-name', 'text-2': 'given-name', email: 'email', phone: 'tel', 'text-3': 'organization', 'text-4': 'address-level2' }).forEach(([name, autocomplete]) => {
        byName(name).setAttribute('autocomplete', autocomplete);
      });
      byName('email').setAttribute('type', 'email');
      byName('email').setAttribute('inputmode', 'email');
      byName('phone').setAttribute('type', 'tel');
      byName('phone').setAttribute('inputmode', 'tel');
      byName('phone').setAttribute('default-country-code', 'fr');
      const guests = byName('text-5');
      guests.setAttribute('type', 'number');
      guests.setAttribute('min', '10');
      guests.setAttribute('step', '1');
      guests.setAttribute('inputmode', 'numeric');
      guests.setAttribute('required', '');
      guests.setAttribute('aria-required', 'true');
      controls.forEach((field) => {
        field.closest('.globo-form-control').dataset.aqField = eventNames.includes(field.name) ? 'event' : 'contact';
      });
      footer.dataset.aqNativeFooter = 'true';
      form.dataset.aqEnhanced = 'true';
      let view = 'event';

      const focusElement = (node) => {
        node.focus({ preventScroll: true });
        node.scrollIntoView({ block: 'center', behavior: 'auto' });
      };

      const show = (target, focus = false) => {
        view = target;
        root.dataset.aqView = target;
        navigation.hidden = target === 'all';
        progress.hidden = target === 'all';
        count.hidden = target === 'all';
        next.hidden = target !== 'event';
        back.hidden = target !== 'contact';
        title.textContent = root.dataset[target === 'event' ? 'titleEvent' : target === 'contact' ? 'titleContact' : 'titleAll'];
        lead.textContent = root.dataset[target === 'event' ? 'leadEvent' : target === 'contact' ? 'leadContact' : 'leadAll'];
        count.firstChild.textContent = target === 'contact' ? '02 ' : '01 ';
        progress.classList.toggle('is-second', target === 'contact');
        Array.from(progress.children).forEach((item, index) => {
          const current = index === (target === 'contact' ? 1 : 0);
          item.classList.toggle('is-current', current);
          item.classList.toggle('is-complete', target === 'contact' && index === 0);
          if (current) item.setAttribute('aria-current', 'step');
          else item.removeAttribute('aria-current');
        });
        if (focus) focusElement(title);
      };

      const firstInvalid = (fields) => fields.find((field) => {
        if (field.disabled) return false;
        const required = field.required || field.hasAttribute('presence');
        if (required && !String(field.value || '').trim()) return true;
        return field.willValidate && !field.checkValidity();
      });

      const displayInvalid = (field) => {
        const fieldView = eventNames.includes(field.name) ? 'event' : 'contact';
        if (view !== 'all') show(fieldView);
        const wrapper = field.closest('.globo-form-control');
        const label = wrapper?.querySelector('.label-content')?.textContent?.trim() || '';
        error.textContent = `${root.dataset.invalid} ${label}`.trim();
        error.hidden = false;
        focusElement(field);
        if (field.willValidate && !field.validity.valid) field.reportValidity();
      };

      const continueToContact = () => {
        const invalid = firstInvalid(eventControls);
        if (invalid) return displayInvalid(invalid);
        error.hidden = true;
        show('contact', true);
      };

      next.addEventListener('click', continueToContact);
      back.addEventListener('click', () => { error.hidden = true; show('event', true); });
      all.addEventListener('click', () => { error.hidden = true; show('all', true); });
      form.addEventListener('keydown', (event) => {
        if (view !== 'event' || event.key !== 'Enter' || event.isComposing) return;
        if (!(event.target instanceof HTMLInputElement) || event.target.classList.contains('flatpickr-input')) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        continueToContact();
      }, true);
      form.addEventListener('submit', (event) => {
        if (view === 'event') {
          event.preventDefault();
          event.stopImmediatePropagation();
          continueToContact();
          return;
        }
        const invalid = firstInvalid(controls);
        if (invalid) {
          event.preventDefault();
          event.stopImmediatePropagation();
          displayInvalid(invalid);
          return;
        }
        error.hidden = true;
        show('all');
      }, true);

      const errorObserver = new MutationObserver(() => {
        if (view === 'all') return;
        const appError = Array.from(form.querySelectorAll('.messages, .message.error')).some((node) => node.textContent.trim());
        if (appError) show('all');
      });
      errorObserver.observe(form, { subtree: true, childList: true, characterData: true });
      form.addEventListener('reset', () => {
        window.setTimeout(() => { error.hidden = true; show('event'); }, 0);
      });
      show('event');
      return true;
    };

    if (!enhance()) {
      const ready = () => {
        if (!enhance()) return;
        observer.disconnect();
        document.removeEventListener('globo.formbuilder.form.loaded', ready);
      };
      const observer = new MutationObserver(ready);
      observer.observe(mount, { childList: true, subtree: true, attributes: true, attributeFilter: ['type', 'class'] });
      document.addEventListener('globo.formbuilder.form.loaded', ready);
      window.setTimeout(() => observer.disconnect(), 30000);
    }
  });
})();
